module.exports = __webpack_public_path__ + "static/lif-response-3-e7ecb79640b96811108b7be77ddec9cb.mp4";